import { render, staticRenderFns } from "./ConfirmManuallyPayment.vue?vue&type=template&id=0bdb4499"
import script from "./ConfirmManuallyPayment.vue?vue&type=script&lang=js"
export * from "./ConfirmManuallyPayment.vue?vue&type=script&lang=js"
import style0 from "./ConfirmManuallyPayment.vue?vue&type=style&index=0&id=0bdb4499&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports